import React, { memo } from "react";
import { Row, Col } from "antd";
import RenderInput from "./RenderInput";
import RenderDeleteButton from "./RenderDeleteButton";

const CardTitle = ({
  onInputChange,
  index,
  keyTitle,
  value,
  itemId,
  nestedIndex,
  dragToggle,
  placeholder,
  deleteSection,
  newId,
}) => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={10}>
          <RenderInput
            index={index}
            //   key={key}
            onInputChange={onInputChange}
            keyTitle={keyTitle}
            placeholder={placeholder}
            value={value}
            id={itemId}
            newId={newId}
          />
        </Col>
        <Col span={10}></Col>
        <Col span={4}>
          {!dragToggle && (
            <RenderDeleteButton
              title="Delete"
              id={itemId}
              childId={nestedIndex}
              deleteSection={deleteSection}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default memo(CardTitle);
